// Created on 2023-08-03
// Created by Vitaut Tryputsin
//
// Copyright (c) 2023 OPEN CASCADE SAS
//
// This file is part of commercial software by OPEN CASCADE SAS,
// furnished in accordance with the terms and conditions of the contract
// and with the inclusion of this copyright notice.
// This file or any part thereof may not be provided or otherwise
// made available to any third party.
//
// No ownership title to the software is transferred hereby.
//
// OPEN CASCADE SAS makes no representation or warranties with respect to the
// performance of this software, and specifically disclaims any responsibility
// for any damages, special or consequential, connected with its use.
import { InteractiveObject } from "../interactive-object.js";
/**
 * Represents text label object which can be displayed in the Viewer.
 *
 * This class is a wrapper around functions of [[PmiController]].
 * This class contains week reference to actual text label object.
 * You can create new text label object or use existing one by pass string id of existing object.
 *
 * See also [[UserEvents]]`.onEditTextLabel` callback for tracking changes.
 */
export class TextLabel extends InteractiveObject {
    /**
     * Constructor.
     * @param theModule Viewer object.
     * @param theParams Params of new length dimension or string id to use existing one.
     */
    constructor(theModule, theParams) {
        if (typeof theParams == 'string') {
            super(theModule, theParams);
        }
        else {
            if (theParams.id && theModule.interactiveContext.areObjectsInside(theParams.id)) {
                theModule.pmi.editTextLabel(theParams, false);
                super(theModule, theParams.id);
            }
            else {
                const anId = theModule.pmi.addTextLabel(theParams, false);
                super(theModule, anId);
            }
        }
    }
    /** Get point position. */
    get pointPosition() {
        return this._myViewer.pmi.textLabelParams(this._myObjId).pointPosition;
    }
    /** Set point position. */
    set pointPosition(theValue) {
        const aParams = this._myViewer.pmi.textLabelParams(this._myObjId);
        aParams.pointPosition = theValue;
        this._myViewer.pmi.editTextLabel(aParams, false);
    }
    /** Get text position. */
    get textPosition() {
        return this._myViewer.pmi.textLabelParams(this._myObjId).textPosition;
    }
    /** Set text position. */
    set textPosition(theValue) {
        const aParams = this._myViewer.pmi.textLabelParams(this._myObjId);
        aParams.textPosition = theValue;
        this._myViewer.pmi.editTextLabel(aParams, false);
    }
    /** Get text. */
    get text() { return this._myViewer.pmi.textLabelParams(this._myObjId).text; }
    /** Set text. */
    set text(theValue) {
        const aParams = this._myViewer.pmi.textLabelParams(this._myObjId);
        aParams.text = theValue;
        this._myViewer.pmi.editTextLabel(aParams, false);
    }
    /** Get text label params. */
    get params() { return this._myViewer.pmi.textLabelParams(this._myObjId); }
    /** Set text label params. */
    set params(theParams) {
        if (theParams.id != this._myObjId) {
            throw new Error(`Wrong object id: provided ${theParams.id} but should be ${this._myObjId}`);
        }
        this._myViewer.pmi.editTextLabel(theParams, false);
    }
}
